class UserCtrl {

    constructor($scope, $location, UserService, EVENTS, $rootScope) {

        this.$location = $location;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$scope.error = false;
        this.$scope.path = $location.path();
        this.UserService = UserService;
        this.path = $location.path();
        this.EVENTS = EVENTS;
        this.$rootScope = $rootScope;

        this.collapsed = false;
        this.account = null;
        this.advertiser = null;
        this.campaign = null;
        this.feed = null;
        this.recent = [];

        $scope.$root.$on(EVENTS.SET_TITLE, this.setTitle.bind(this));

        $scope.logout = this.logout.bind(this);

        $rootScope.$watch("currentUser", () => {
            $scope.currentUser = $rootScope.currentUser;
            if($rootScope.currentUser && $rootScope.currentUser.settings) {
                this.setSettings($rootScope.currentUser.settings);
            }
        });

        if(!$rootScope.currentUser) {
            this.UserService.getCurrentUser().then( () => console.log("User is logged in") );
        }

        $rootScope.$on('$routeChangeStart', (event, next, current) => {
            if(next.$$route) {
                $scope.path = next.$$route.originalPath;
            }
            else {
                $scope.path = "/accounts";
            }
            this.path = $scope.path;
        });

        $rootScope.$on(EVENTS.SET_RECENT_CAMPAIGN, (ev, args) => {
            this.addRecentCampaign(args);
        });

    }

    setTitle(event, title) {
        const TITLE = 'Reflow';

        this.$scope.$root.title = title ? title + ' | ' + TITLE : TITLE;
    }

    logout() {
        this.UserService.logout()
          .then((response) => { 
                localStorage.clear();
                this.$location.path('/login');
            }, (response) => {
                console.error(response);
                this.$scope.error = true;
        });
    }

    toggleSidebar() {
        this.collapsed = !this.collapsed;
        this.saveSettings();
    }

    hasRole(role) {
        return !!this.$rootScope.currentUser && this.$rootScope.currentUser.securityRoles.indexOf(role) > -1;
    }

    getCurrentUser() {
        this.UserService.getCurrentUser()
            .then((response) => { 

            });
    }

    setCurrentAccount(event, account) {
        this.account = account;
    }

    setCurrentAdvertiser(event, advertiser) {
        this.advertiser = advertiser;
    }

    setCurrentCampaign(event, campaign) {
        this.campaign = campaign;
        if(this.campaign.lastPublished !== null && "undefined" !== typeof this.campaign.lastPublished && this.campaign.lastPublished && !isNaN(this.campaign.lastPublished)) {
            this.campaign.lastPublished = moment(this.campaign.lastPublished).format('DD/MM/YYYY HH:mm:ss');
        }
        let regex = /^\/account\/(?:([^\/]+))\/(?:([^\/]+))\/campaign\/(?:([^\/]+))$/;
        if (regex.test(this.$location.url())) {
            this.addRecentCampaign(campaign, this.$location.url());
        }
        this.saveSettings();
    }

    setCurrentFeed(event, feed) {
        this.feed = feed;
    }

    addRecentCampaign(args) {
        this.recent = this.recent.filter(item => item.path !== args.path);
        this.recent.unshift(args);
        this.recent = this.recent.slice(0, 5);
        this.saveSettings();
    }

    setSettings(settingsString) {
        let settings = JSON.parse(settingsString);
        this.collapsed = settings.collapsed;
        this.recent = settings.recent;
    }

    saveSettings() {
        let settings = {
            collapsed: this.collapsed,
            recent: this.recent
        };
        this.UserService.updateSettings(JSON.stringify(settings));
    }

}

angular.module('cpm')
    .controller('UserCtrl', ['$scope', '$location', 'UserService', 'EVENTS', '$rootScope', UserCtrl]);
